$(function() {
	$('.js-faq-item').click(function (e) {
		e.preventDefault();
		$('.js-faq-item').not(this).removeClass('faq__item_active').next().slideUp();
		$(this).toggleClass('faq__item_active').next().slideToggle();
	});
})